import React, { useEffect } from "react";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import PageHero from "../components/PageHero";

export default function Blog() {
  useEffect(() => {
    document.title = 'Blog — Learning Outcomes Academy';
    return () => { document.title = 'Learning Outcomes Academy'; };
  }, []);
  return (
    <div className="w-full">
      <PageHero
        eyebrow="Insights & Updates"
        title={
          <>
            Notes on{" "}
            <span className="italic text-brand-deep">accreditation, research,</span>{" "}
            and education.
          </>
        }
        lead="A growing collection of articles and practical notes on the work the academy supports — from research design and writing to accreditation preparation and program development."
      />

      <section className="bg-bone">
        <div className="container-page py-16 lg:py-24">
          <div className="rounded-3xl bg-cream border border-ink/10 p-10 lg:p-14 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <div className="eyebrow eyebrow-bar">Currently writing on Medium</div>
              <h2 className="mt-5 font-display text-3xl lg:text-4xl leading-tight tracking-tightish text-ink">
                Read the academy's latest writing on Medium.
              </h2>
              <p className="mt-4 text-slate2 leading-relaxed text-lg">
                Articles, helpful tips, and reflections on accreditation, research,
                program development, and lifelong learning — published regularly on
                Medium while we build out our on-site library.
              </p>
            </div>
            <div className="lg:col-span-4 lg:text-right">
              <a
                href="https://drqwrites.medium.com"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
              >
                Visit our blog{" "}
                <FaArrowUpRightFromSquare className="text-xs" />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
